import { FunctionComponent } from 'react';
import {
  serializationOptionsForStringArrayValue,
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

import { FilterContext, FilterState } from './FilterContext';

enum QUERY_PARAMS {
  SEARCH = 'search',
  FILE_TYPE = 'fileType',
  CREATED_BY_USER_ID = 'createdByUserId',
  UPDATED_BY_USER_ID = 'updatedByUserId',
  FILE_SIZE = 'fileSize',
}

export const FilterContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [searchQuery, setSearchQuery] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.SEARCH,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  const [fileType, setFileType] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.FILE_TYPE,
    stateValueWhenSearchParamIsUnset: [],
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringArrayValue,
  });

  const [createdByUserId, setCreatedByUserId] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.CREATED_BY_USER_ID,
    stateValueWhenSearchParamIsUnset: [],
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringArrayValue,
  });

  const [updatedByUserId, setUpdatedByUserId] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.UPDATED_BY_USER_ID,
    stateValueWhenSearchParamIsUnset: [],
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringArrayValue,
  });

  const [fileSize, setFileSize] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.FILE_SIZE,
    stateValueWhenSearchParamIsUnset: [],
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringArrayValue,
  });

  const hasFilters =
    fileType.length > 0 ||
    searchQuery.trim().length > 0 ||
    createdByUserId.length > 0 ||
    updatedByUserId.length > 0 ||
    fileSize.length > 0;

  const clearFilters = () => {
    setFileType([]);
    setCreatedByUserId([]);
    setUpdatedByUserId([]);
    setFileSize([]);
  };

  const context: FilterState = {
    fileType,
    setFileType,
    searchQuery,
    setSearchQuery,
    createdByUserId,
    setCreatedByUserId,
    updatedByUserId,
    setUpdatedByUserId,
    fileSize,
    setFileSize,
    hasFilters,
    clearFilters,
  };

  return <FilterContext.Provider value={context}>{children}</FilterContext.Provider>;
};
